import { getTestIds } from '../../utils/TestIds';
export const GetDateCalendarTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            DateCalendarTestIds: {
                Root: (testId)=>testId !== null && testId !== void 0 ? testId : '',
                PrevMonth: (testId)=>testId ? "".concat(testId, "-prev-month") : '',
                MonthLabel: (testId)=>testId ? "".concat(testId, "-month-label") : '',
                NextMonth: (testId)=>testId ? "".concat(testId, "-next-month") : '',
                Day: (testId, year, month, date)=>"".concat(testId, "-day-").concat(year, "-").concat(month, "-").concat(date),
                DayTooltip: (testId, year, month, date)=>"".concat(testId, "-day-").concat(year, "-").concat(month, "-").concat(date, "-tooltip"),
                Action: (testId, index)=>"".concat(testId, "-action-").concat(index)
            }
        }
    });
export const GetDatePickerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            DatePickerTestIds: {
                Root: (testId)=>testId !== null && testId !== void 0 ? testId : '',
                Input: (testId)=>testId ? "".concat(testId, "-input") : '',
                InputWrap: (testId)=>testId ? "".concat(testId, "-input-wrap") : '',
                InputBadge: (testId)=>testId ? "".concat(testId, "-input-badge") : '',
                Label: (testId)=>testId ? "".concat(testId, "-label") : '',
                HelperText: (testId)=>testId ? "".concat(testId, "-helper-text") : '',
                Btn: (testId)=>testId ? "".concat(testId, "-btn") : '',
                Loading: (testId)=>testId ? "".concat(testId, "-loading") : '',
                Popover: (testId)=>testId ? "".concat(testId, "-popover") : '',
                BottomSheet: (testId)=>testId ? "".concat(testId, "-bottom-sheet") : '',
                BottomSheetTitle: (testId)=>testId ? "".concat(testId, "-bottom-sheet-title") : '',
                Row: (testId)=>testId ? "".concat(testId, "-row") : '',
                RowLabel: (testId)=>testId ? "".concat(testId, "-row-label") : '',
                RowValue: (testId)=>testId ? "".concat(testId, "-row-value") : '',
                RowEditBtn: (testId)=>testId ? "".concat(testId, "-row-edit-btn") : ''
            }
        }
    });
